<!-- =========================================================================================
   File Name: categoryView.vue
    Description: Category
    ----------------------------------------------------------------------------------------
    Item Name: KOZO Admin - VueJS Dashboard
    Author:
    Author URL:
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
    <div class="vx-row">
      <div class="vx-col w-full">
        <router-link to="/contractView">
          <feather-icon icon="ArrowLeftCircleIcon" svgClasses="h-8 w-8" />
        </router-link>
      </div>
      <!-- WORK TYPE FORMS -->
      <div class="vx-col w-full mb-base">
        <!-- v-if="checkPermission(['workType','GET'])" -->
        <projectTypeForm />
      </div>

      <!-- WORK TYPE LIST -->
      <div class="vx-col w-full">
        <vs-tabs>
          <vs-tab label="Project Type List" icon-pack="feather" icon="icon-box">
            <div class="tab-text">
              <!-- WORK TYPE LIST -->
              <div>
                <!-- v-if="checkPermission(['workType','POST'])" -->
                <projectTypeList />
              </div>
            </div>
          </vs-tab>
          <vs-tab label="Archive List" icon-pack="feather" icon="icon-box">
            <!-- WORK TYPE ARCHIVE LIST -->
            <div>
              <projectTypeList listType="archive" />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import projectTypeForm from "@/views/apps/contractprojectType/projectTypeForm.vue";
import projectTypeList from "@/views/apps/contractprojectType/projectTypeList.vue";

export default {
  data() {
    return {
      isActive: false,
      analyticsData: [],
      isImp: false,
      navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
      show: false,
      items: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      nextNum: 10,
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot"
      ]
    };
  },
  methods: {
    myFilter: function() {
      this.isActive = !this.isActive;
    }
  },
  components: {
    projectTypeForm,
    projectTypeList
  }
};
</script>

<style lang="scss">
#dashboard-analytics {
  .greet-user {
    position: relative;
    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
</style>
